<template>
  <div class="wrapper">
    <div
      class="drag-and-drop"
      data-test="drag-and-drop"
    >
      <div class="column-header">
        {{ columnHeaders[0] }}
      </div>
      <div class="column-header">
        {{ columnHeaders[1] }}
      </div>
      <div class="answer-column">
        <draggable
          v-model="answerColumn"
          v-bind="dragOptions"
          :move="onMove"
          class="full-height"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <div
              v-for="(answer) in answerColumn"
              :key="answer.id"
              class="answer"
              :data-test="`answer-choice-${answer.id}`"
              @click="selectAnswer(answer)"
            >
              {{ answer.text }}
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="answer-column selected-answers">
        <draggable
          v-model="selectedAnswers"
          v-bind="dragOptions"
          :move="onMove"
          class="full-height"
          :style="{ minHeight: columnHeight + 'rem' }"
        >
          <transition-group
            type="transition"
          >
            <div
              v-for="(answer) in selectedAnswers"
              :key="answer.id"
              class="answer"
              :data-test="`answer-choice-${answer.id}`"
              @click="selectAnswer(answer)"
            >
              {{ answer.text }}
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  props: {
    flashcard: {
      type: Object,
      required: true,
    },
    flashcardState: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answerColumn: [],
      selectedAnswers: [],
      isDragging: false,
      delayedDragging: false,
    };
  },
  computed: {
    columnHeight() {
      return this.flashcard.answers.length * 4.5 + 0.375;
    },
    columnHeaders() {
      return (
        this.flashcard?.matrixGridColumnHeaders ||
        ['column1', 'column2']
      );
    },
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        ghostClass: 'ghost',
      };
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    selectedAnswers(newValue) {
      this.$emit('answers-selected', newValue.map((a) => a.id));
    },

    flashcard() {
      this.selectedAnswers = this.flashcardState?.answerIds
        ? this.flashcard.answers.filter((a) =>
            this.flashcardState.answerIds.includes(a.id)
          )
        : [];
      this.answerColumn = this.flashcard.answers.filter(
        (a) => !this.selectedAnswers.includes(a)
      );
    },
  },
  mounted() {
    this.selectedAnswers = this.flashcardState?.answerIds
        ? this.flashcard.answers.filter((a) =>
            this.flashcardState.answerIds.includes(a.id)
          )
        : [];
    this.answerColumn = this.flashcard.answers.filter(
      (a) => !this.selectedAnswers.includes(a)
    );
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    selectAnswer(answer) {
      if (this.isDragging || this.delayedDragging) return;
      if (this.selectedAnswers.includes(answer)) {
        this.selectedAnswers = this.selectedAnswers.filter(
          (a) => a.id !== answer.id
        );
        this.answerColumn.push(answer);
        return;
      }
      this.selectedAnswers.push(answer);
      this.answerColumn = this.answerColumn.filter(
        (a) => a.id !== answer.id
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: calc(100% - 1.5rem);
}

.flashcard-instructions {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
.drag-and-drop {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;

  .answer-column {
    border: 1px solid black;
  }
  .selected-answers {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .answer {
    background: #d9edf8;
    border: 1px solid #c7d8e1;
    padding: 1.5rem 1rem;
    margin: 0.25rem;
    cursor: grab;
  }

  .sortable-chosen {
    cursor: grabbing;
  }

  .ghost {
    opacity: 0.2;
    background: lightblue;
  }

  .full-height {
    height: 100%;

    span {
      display: block;
      height: 100%;
    }
  }

  .column-header {
    border: 1px solid black;
    border-bottom: none;
    padding: 0.75rem 1rem;
    font-weight: 600;
  }
}

</style>
